<!-- Watermark.vue -->
<template>
  <div class="watermark-container">
    <div
        v-for="i in repetitions"
        :key="i"
        class="watermark-item"
        :style="{ transform: `rotate(${angle}deg) translateY(${offsetY * (i % rows)}px) translateX(${offsetX * Math.floor(i / rows)}px)` }"
    >
      {{ watermarkText }}
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';

const props = defineProps({
  watermarkText: { type: String, required: true }, // 要显示的文字（通常是用户ID）
  color: { type: String, default: 'rgba(100, 100, 100, 0.2)' }, // 默认灰色半透明
  fontSize: { type: Number, default: 16 },     // 字体大小
  angle: { type: Number, default: -45 },        // 倾斜角度（负值为逆时针）
  density: { type: Number, default: 4 },        // 每行重复次数（密度控制）
});

// 计算总行列数以达到铺满效果
const repetitions = computed(() => props.density * props.density);
const rows = ref(props.density);
const cols = ref(props.density);

// 自动调整间距以适应视口变化
const offsetX = computed(() => window.innerWidth / cols.value);
const offsetY = computed(() => window.innerHeight / rows.value);

// 监听窗口大小变化，调整水印位置
watch(() => [window.innerWidth, window.innerHeight], () => {
  offsetX.value = window.innerWidth / cols.value;
  offsetY.value = window.innerHeight / rows.value;
});
</script>

<style scoped>
.watermark-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none; /* 确保不会阻挡下方元素的鼠标事件 */
  z-index: 9999;
  display: flex;
  flex-wrap: wrap;
}

.watermark-item {
  color: v-bind(color);
  font-size: v-bind(fontSize + 'px');
  white-space: nowrap;
  user-select: none;
}
</style>